import React, {useState } from 'react'
import { Overlay, Popover } from 'react-bootstrap'
import { InfoCircle } from 'react-bootstrap-icons'

const InfoIconOverlay = (props) => {

  const [show, setShow] = useState(false)
  const [target, setTarget] = useState(null)

  const handleShowPopover = (event) => {
    setShow(true)
    setTarget(event.target)
  }

  const handleHidePopover = (event) => {
    setShow(false)
    setTarget(null)
  }


  return (
    <>
      <InfoCircle
        color={props.infoCircleColor}
        style={props.InfoCircleStyle}
        onMouseEnter={handleShowPopover}
        onMouseLeave={handleHidePopover}
        onClick={handleShowPopover}
      />
      <Overlay
        show={show}
        target={target}
        placement='right'
        transition={false}
        rootClose
        onHide={handleHidePopover}
      >
      <Popover style={props.popoverStyle}>
        <Popover.Content>
          <strong>
            {props.text}
          </strong>
        </Popover.Content>
      </Popover>
        
      </Overlay>
    </>
  )
}

InfoIconOverlay.defaultProps = {
  popoverStyle: {border: '2px solid #007bff'},
  infoCircleColor: '#007bff',
  InfoCircleStyle: {marginLeft: '10px'},
}

export default InfoIconOverlay
